import React, { Component, ReactNode } from 'react';
import Datetime from 'react-datetime';
import { CONSTANTS } from 'components/shared/constants';
import moment, { Moment } from 'moment';
import { EventTarget, Attributes } from './types';

interface IProps {
  value: string;
  utc?: boolean;
  type?: string;
  name: string;
  onChange: (e: EventTarget) => void;
  attributes: Attributes;
  className?: string;
  required: boolean;
}

class DatetimePicker extends Component<IProps> {
  defaultValue: Moment;

  dateTimeRef: React.RefObject<HTMLInputElement>;

  constructor(props: IProps) {
    super(props);
    const { value, utc = true } = this.props;

    this.defaultValue = utc ? moment.utc(value) : moment(value);
    this.dateTimeRef = React.createRef();
  }

  onChange = (value: string | Moment): void => {
    const { type, name, onChange } = this.props;
    const e = { target: { type, name, value } };

    if (typeof value === 'string' || value instanceof String) {
      this.dateTimeRef.current?.setCustomValidity('Invalid date');
    } else {
      this.dateTimeRef.current?.setCustomValidity('');
    }

    onChange(e as EventTarget);
  };

  renderInput(props: object) {
    return <input ref={this.dateTimeRef} {...props} />;
  }

  render(): ReactNode {
    const { name, required, attributes, utc = true } = this.props;
    const { dateTimeFormat = {}, disabled = false } = attributes;
    const { DATE_FORMAT, TIME_FORMAT } = CONSTANTS;
    const { dateFormat = DATE_FORMAT, timeFormat = TIME_FORMAT } = dateTimeFormat;

    const currentDateFormat = dateFormat === null ? false : DATE_FORMAT;
    const currentTimeFormat = timeFormat === null ? false : TIME_FORMAT;

    return (
      <Datetime
        inputProps={{
          className: 'cc-input',
          placeholder: 'Date Time, UTC',
          disabled,
          required,
          name,
        }}
        renderInput={this.renderInput.bind(this)}
        utc={utc}
        dateFormat={currentDateFormat}
        timeFormat={currentTimeFormat}
        initialValue={this.defaultValue}
        onChange={this.onChange}
      />
    );
  }
}

export default DatetimePicker;
